import VPicker from './VPicker'

/* istanbul ignore next */
VPicker.install = function install (Vue) {
  Vue.component(VPicker.name, VPicker)
}

export default VPicker



// WEBPACK FOOTER //
// ./src/components/VPicker/index.js